import jwt from "jsonwebtoken";

/** Decodes an AG-Grid API key token */
export const decode_grid_token = (token: string): string => {
    let decoded = jwt.decode(token);
    if (typeof decoded !== "object" || decoded === null) return null;
    else if (!decoded.key) return null;
    else return decoded.key;
};